/******************************************************************************
 * @Author                : Jbristhuille<jbristhuille@gmail.com>              *
 * @CreatedDate           : 2025-02-10 15:21:56                               *
 * @LastEditors           : Jbristhuille<jbristhuille@gmail.com>              *
 * @LastEditDate          : 2025-03-03 14:58:36                               *
 *****************************************************************************/

/* SUMMARY
  * Imports
  * Components
  * WorkorderListItem: Display workorder list item
*/

/* Imports */
/***/

/* Components */
import toast from "react-hot-toast";
import { showApiErrorToast } from "../../../../../../services/api/error";
/***/

import EditCreateDrawer from "../../../../../../components/edit-create-drawer/EditCreateDrawer";
import { validator } from "../../../../../../services/form-validator/form-validator";
import { api } from "../../../../../../services/api/api";
import LanguageForm, { LanguageFormValidator } from "../../../../../../components/data/language/LanguageForm";
import { useState } from "react";

/**
* WorkorderListItem: Display workorder list item
* @param workorder - Workorder data
* @param onClick - On click event
* @param isLast - Is last item
*/
export default function LanguagesAdminActions({
  lang,
  onChange
}: {
  lang: EasyTech.Language,
  onChange: () => void
}) {

  const [isEnable, setEnable] = useState(lang.enabled);
  /**
  * updateTechnician: update technician information
  * @param tech - technician data to update
  */
  const updateLanguage = (lang: EasyTech.Language): Promise<void> => {
    return new Promise((resolve, reject) => {
      const isDef = lang.default !== undefined ? lang.default : (lang.isDefault !== undefined ? lang.isDefault : false);
      const normalizedLang: EasyTech.Language = {
        ...lang,
        label: lang.label || "",
        isoCode: lang.isoCode || "",
        default: isDef,
        isDefault: isDef,
        enabled: lang.enabled !== undefined ? lang.enabled : true
      };
      
      if (validator.isFormValid(normalizedLang, LanguageFormValidator)) {
        api.put(`admin/languages/${normalizedLang.id}`, normalizedLang).then((ret) => {
          if (isEnable !== normalizedLang.enabled) {
            api.delete(`admin/languages/${normalizedLang.enabled ? "enable" : "disable"}/${normalizedLang.id}`).then((ret) => {
              setEnable(normalizedLang.enabled);
              onChange();
              toast.success("Language updated");
              return resolve();
            }).catch((error) => {
              console.error(error);
              showApiErrorToast(error, { fallbackMessage: "Erreur lors du changement d'état de la langue" });
              return reject();
            });
          } else {
            onChange();
            toast.success("Language updated");
            return resolve();
          }
          
        }).catch((error) => {
          console.error(error);
          showApiErrorToast(error, { fallbackMessage: "Erreur lors de la mise à jour de la langue" });
          return reject();
        });
      } else {
        toast.error("Form is invalid");
        return reject();
      }
    });
  };
  /***/

  return(
    <div className="admin-wo-actions">
      <EditCreateDrawer data={(lang as EasyTech.Language)}
                        entityName="Language"
                        FormComponent={LanguageForm}
                        isNotCreatable={true}
                        onSubmit={updateLanguage}/>
          
    </div>
  );
}
/***/
